import React, { useState } from 'react';
import { Modal } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder as api, apis } from 'api';
import IconCard from '../IconCard';
import { getIn18Text } from 'api';
const codeContMap = {
    10304: getIn18Text('GERENKONGJIANRONG'),
    10206: getIn18Text('BAOCUNSHIBAI\uFF0C'),
};
const TransferButton = props => {
    const { children = getIn18Text('BAOCUNDAOGEREN1'), downloadInfo, onChange, cancelSave = false } = props;
    const [lockVisible, setLockModalVisible] = useState(false);
    const diskApi = api.api.requireLogicalApi(apis.netStorageImpl);
    const systemApi = api.api.getSystemApi();
    const handleError = (code, type) => {
        if (code === 10403) {
            message.error({
                icon: React.createElement(IconCard, { type: "info", stroke: "white", style: { width: 15, height: 15, marginRight: 8 } }),
                content: getIn18Text('FUWUWEIKAITONG'),
                duration: 2,
            });
            return;
        }
        if (code) {
            message.error({
                icon: React.createElement(IconCard, { type: "info", stroke: "white", style: { width: 15, height: 15, marginRight: 8 } }),
                content: codeContMap[code] || getIn18Text('CAOZUOSHIBAI\uFF0C'),
                duration: 2,
            });
        }
        else {
            const defContent = type === 'cloud' ? 'WENJIANBUCUNZAIYIGUOQI' : 'CAOZUOSHIBAI\uFF0C';
            message.error({
                icon: React.createElement(IconCard, { type: "info", stroke: "white", style: { width: 15, height: 15, marginRight: 8 } }),
                content: getIn18Text(defContent),
                duration: 2,
            });
        }
    };
    const storePriSpaceAction = async (identity) => {
        const params = { identity };
        try {
            await diskApi.saveCloudAttachment(params);
            message.success({
                content: getIn18Text('YIBAOCUN\uFF0CKE'),
                duration: 2,
            });
        }
        catch (e) {
            const { code } = e.data;
            handleError(code, 'cloud');
        }
    };
    const extractIdentity = (identityUrl) => {
        try {
            const urlObject = new URL(identityUrl);
            return urlObject.searchParams.get('identity');
        }
        catch (error) {
            return '';
        }
    };
    const actionSave = async () => {
        var _a;
        if (cancelSave) {
            return;
        }
        try {
            const isLocked = await diskApi.isLockEnabledUsingGET();
            if (isLocked) {
                setLockModalVisible(true);
                onChange && onChange(isLocked);
                return;
            }
            if (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.cloudAttachment) {
                const identityUrl = (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileUrl) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileOriginUrl);
                const identity = extractIdentity(identityUrl);
                storePriSpaceAction(identity);
                return;
            }
            await diskApi.saveMailAttachment({
                fileName: encodeURI(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName),
                fileSize: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileSize,
                mid: (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId) || (downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.contentId),
                part: downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.id,
                host: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host,
            });
            message.success({
                content: getIn18Text('HOUTAIBAOCUNZHONG'),
                duration: 4,
            });
        }
        catch (error) {
            let code;
            error && 'data' in error && ({ code } = error.data);
            handleError(code);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: actionSave }, children),
        React.createElement(Modal, { visible: lockVisible, okText: getIn18Text('QIANWANGJIESUO'), cancelText: getIn18Text('ZHIDAOLE'), onCancel: () => setLockModalVisible(false), closable: false, onOk: () => systemApi.openNewWindow('https://qiye.163.com', false) },
            React.createElement("h2", null, getIn18Text('GERENKONGJIANYI')),
            React.createElement("div", null, getIn18Text('KEQIANWANGWANGYI')))));
};
export default TransferButton;
